import { render, staticRenderFns } from "./ShowOtoscopy.vue?vue&type=template&id=57182869"
import script from "./ShowOtoscopy.vue?vue&type=script&lang=js"
export * from "./ShowOtoscopy.vue?vue&type=script&lang=js"
import style0 from "./ShowOtoscopy.vue?vue&type=style&index=0&id=57182869&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports